<script setup>
  import UpgradeBlock from '@/components/UpgradeBlock.vue';
  import { useUserUpgrades } from '@/composables/useUserUpgrades';

  const { upgrade } = useUserUpgrades({ minMemberLevel: 49 });
</script>

<template>
  <UpgradeBlock productText="<strong>Pro Forecasts</strong>" :upgrade="upgrade" clickLocation="Pro Forecast Banner" />
</template>